import React, { createContext, useContext, useState, ReactNode } from 'react';

// ✅ 1. กำหนดโครงสร้างข้อมูลที่ต้องใช้ (ต้องมีทั้ง jobId และ portId)
export interface JobData {
  jobId: string;
  portId: string;
}

// ✅ 2. อัปเดต Type ให้รองรับ JobData แทน String
interface ImportJobContextType {
  jobData: JobData | null;
  setJobData: (data: JobData | null) => void;
}

// สร้าง Context
const ImportJobContext = createContext<ImportJobContextType | undefined>(undefined);

// สร้าง Provider
export const ImportJobProvider = ({ children }: { children: ReactNode }) => {
  // ✅ 3. เปลี่ยนชื่อตัวแปร State
  const [jobData, setJobData] = useState<JobData | null>(null);

  return (
    <ImportJobContext.Provider value={{ jobData, setJobData }}>
      {children}
    </ImportJobContext.Provider>
  );
};

// Custom Hook สำหรับเรียกใช้ง่ายๆ
export const useImportJob = () => {
  const context = useContext(ImportJobContext);
  if (!context) {
    throw new Error('useImportJob must be used within an ImportJobProvider');
  }
  return context;
};